import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage as setPageAction } from "../../actions/advancedListActions";
import {
  handleChange as handleChangeAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../actions/handleChangeAction";

import map from "lodash/map";
import { getMiljogebyrer as getMiljogebyrerAction } from "../../actions/miljogebyrerActions";
import { getOvertredelseskoderMiljogebyr } from "../../actions/overtredelseskoderMiljogebyrActions";
import * as inputValidation from "../../utils/inputValidationUtils";

import { INITIAL_STATE as InnsynMiljogebyererFilterFormStateInitial } from "../../reducers/forms/InnsynMiljogebyrerFilterFormReducer";
import { replaceWhitespacesWithEmptyStrings } from "../../utils/sanitizationUtils";
import { IsValidated } from "../../utils/validationUtils";
import InnsynMiljogebyrFilterForm from "./InnsynMiljogebyrFilterForm";

const rules = {
  ileggelsesnummer: "isPositiveInteger",
};

export default function InnsynMiljogebyerFilterContainer() {
  const dispatch = useDispatch();
  const miljogebyrer = useSelector((state) => state.miljogebyrer);
  const InnsynMiljogebyrerFilterFormState = useSelector(
    (state) => state.forms.InnsynMiljogebyrerFilterFormState,
  );
  const overtredelseskoderMiljogebyr = useSelector(
    (state) => state.overtredelseskoderMiljogebyr,
  );

  const [shallGetIleggelserDueToHandleChangeToInitState, setShallGet] =
    useState(false);
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getOvertredelseskoderMiljogebyr());
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(InnsynMiljogebyrerFilterFormState) ===
        JSON.stringify(InnsynMiljogebyererFilterFormStateInitial) &&
      shallGetIleggelserDueToHandleChangeToInitState === true
    ) {
      setShallGet(false);
    }
  }, [
    InnsynMiljogebyrerFilterFormState,
    shallGetIleggelserDueToHandleChangeToInitState,
  ]);

  // Dispatches a form field change — used by validate() and reset helpers
  const dispatchChange = (variableName, value) =>
    dispatch(
      handleChangeAction(
        "INNSYN_MILJOGEBYRER_FILTER_FORM",
        variableName,
        value,
      ),
    );

  const handleOnChange = (e) => {
    dispatchChange(e.target.name, e.target.value);
  };

  const handleOnChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("INNSYN_MILJOGEBYRER_FILTER_FORM"));
    setShallGet(true);
  };

  const resetValidationErrorText = () => {
    dispatchChange("fraDatoValidationErrorText", null);
    dispatchChange("fraTidValidationErrorText", null);
    dispatchChange("tilDatoValidationErrorText", null);
    dispatchChange("tilTidValidationErrorText", null);
  };

  const validate = () => {
    const { isValid, validationError } = IsValidated(
      { ...InnsynMiljogebyrerFilterFormState },
      rules,
    );
    dispatchChange(
      "validationError.ileggelsesnummer",
      validationError.ileggelsesnummer,
    );
    const fraDateTimeTilDateTimeValid =
      inputValidation.fraDateTimeTilDateTimeValidation(
        InnsynMiljogebyrerFilterFormState,
        dispatchChange,
      );
    return isValid && fraDateTimeTilDateTimeValid;
  };

  const checkFiltersValue = () => {
    const filters = InnsynMiljogebyrerFilterFormState;
    var hasValue = false;
    map(filters, (v) => {
      if (v !== null && v !== "") hasValue = true;
    });
    return hasValue;
  };

  const getFilters = () => {
    let {
      fraTid,
      tilTid,
      fraDatoValidationErrorText,
      fraTidValidationErrorText,
      tilDatoValidationErrorText,
      tilTidValidationErrorText,
      status,
      ...filter
    } = InnsynMiljogebyrerFilterFormState;

    filter = {
      ...filter,
      fraDato: filter.fraDato && filter.fraDato.toISOString(),
      tilDato: filter.tilDato && filter.tilDato.toISOString(),
    };
    return filter;
  };

  const getMiljogebyrerByFilters = () => {
    if (checkFiltersValue() && miljogebyrer.page && miljogebyrer.count) {
      setShowSokSpinner(true);
      const page = 1;
      dispatch(getMiljogebyrerAction(getFilters(), page, miljogebyrer.count))
        .then(() => {
          setShowSokSpinner(false);
          dispatch(setPageAction("miljogebyrer", page));
        })
        .catch(() => setShowSokSpinner(false));
    }
  };

  const handleBlur = (e) => {
    if (e.target.name === "ileggelsesnummer") {
      dispatchChange(
        e.target.name,
        replaceWhitespacesWithEmptyStrings(e.target.value),
      );
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    resetValidationErrorText();
    if (validate()) {
      getMiljogebyrerByFilters();
    }
  };

  return (
    <InnsynMiljogebyrFilterForm
      showSokSpinner={showSokSpinner}
      InnsynMiljogebyrFilterFormState={InnsynMiljogebyrerFilterFormState}
      handleChange={handleOnChange}
      handleChangeToInitState={handleOnChangeToInitState}
      handleBlur={handleBlur}
      onSubmit={handleOnSubmit}
      overtredelseskoderMiljogebyr={overtredelseskoderMiljogebyr}
    />
  );
}
